import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  header {
    margin-bottom: 3em;

    .top--row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 10rem;

      h2 {
        color: #fff;
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0;
      }
    }

    .header--row {
      display: flex;
      align-items: center;
      margin-top: 2em;
      justify-content: space-between;
      gap: 1rem;
      flex-wrap: wrap;

      > div:first-child {
        flex: 1;
        min-width: 250px;
      }

      .add--btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.625rem 1.25rem;
        background: #272B4A;
        border: 0.5px solid rgba(255, 255, 255, 0.08);
        box-sizing: border-box;
        border-radius: 4.02614px;
        color: ${({ theme }) => theme.primary};
        font-weight: 500;
        font-size: 0.875rem;
        cursor: pointer;
        transition: opacity 0.2s;

        svg {
          font-size: 1.125rem;
        }

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }

  .admin--content__container {
    background: #272B4A;
    height: 100%;
    border: 0.765294px solid #272B4A;
    box-sizing: border-box;
    border-radius: 8.74621px;
    display: flex;
    flex-direction: column;
    padding: 1.5em 0px;
    overflow: hidden;

    .loading-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 3rem 2rem;

      p {
        margin-top: 1rem;
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.7);

        .u--color__primary {
          color: ${({ theme }) => theme.primary};
          font-weight: 500;
        }
      }
    }

    .admin--lists--container {
      overflow-y: auto;
      flex: 1;
      height: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
      padding: 1em 2em;
      gap: 1.5em;
      align-content: start;
      
      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 1em;
      }
    }

    .noAdminList--container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 4rem 2rem;
      text-align: center;
      height: 100%;
      max-width: 80%;
      margin: 0 auto;

      h3 {
        font-size: 1.125rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        margin: 1.5em 0px;
      }

      .instruction {
        background: rgba(36, 26, 26, 0.15);
        border: 0.688406px solid rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
        border-radius: 3.44203px;
        padding: 1em 2em;
        font-size: 0.9rem;
        color: rgba(255, 255, 255, 0.4);
        margin-bottom: 1.5rem;
        
        span {
          color: #fff;
        }
      }

      button {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.5rem;
        background: ${({ theme }) => theme.primary};
        color: #fff;
        border: none;
        border-radius: 6px;
        font-weight: 500;
        font-size: 0.875rem;
        cursor: pointer;
        transition: opacity 0.2s;
        margin-top: 2.5em;

        svg {
          font-size: 1.25rem;
        }

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
`

export default Container
